const reducer = (key, value) => {
    switch (key) {
        case 'date_end':
            if (value && typeof value !== 'number') return `${key} must be a number`
            if (value && value < new Date().getTime()) return `Cannot be a past date`
            break
        case 'date_start':
            if (value && typeof value !== 'number') return `${key} must be a number`
            if (value && value < new Date().getTime()) return `Cannot be a past date`
            break
        case 'name':
            if (value && typeof value !== 'string') return `${key} must be a string`
            if (value && value.length < 3) return `At least three characters`
            break
        default:
            return null
    }
}

const reducerWeekdays = (key, value) => {
    switch (key) {
        case 'end_time':
        case 'start_time':
            if (value && typeof value !== 'string') return `${key} must be a string`
            if (value && value.length !== 4) return `it must include 4 characters`
            break
        case 'end_week_day':
        case 'start_week_day':
            if (value && typeof value !== 'number') return `${key} must be a number`
            if (value && (value < 0 || value >= 7)) return `value must be between 0 and 6`
            break
        default:
            return null
    }
}

const compareValues = (values) => {
    const out = {}
    const { end_time = '2359', start_time = '0000' } = values

    if (end_time && start_time && end_time <= start_time) {
        out.end_time = 'Must be later than end_time'
    }

    return out
}

const compareValuesWeekdays = (values) => {
    const out = {}
    const { date_end = Number.MAX_VALUE, date_start } = values

    if (date_end && date_start && date_end <= date_start) {
        out.date_end = 'Must be later than Start Date'
    }

    return out
}

const validate = (values) => ({
    ...compareValues(values),
    ...Object.keys(values).reduce((obj, k) => {
        const out = obj
        const error = reducer(k, values[k])
        if (error) out[k] = error
        return obj
    }, {}),
})

const validateWeekdays = (arrayOfvalues) =>
    arrayOfvalues.map((values) => ({
        ...compareValuesWeekdays(values),
        ...Object.keys(values).reduce((obj, k) => {
            const out = obj
            const error = reducerWeekdays(k, values[k])
            if (error) out[k] = error
            return obj
        }, {}),
    }))

export default validate

export { validateWeekdays }
